import React from "react";
import * as Type from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import type { FilterType } from "../../../../../../../common-deprecated/types/CommonTypes";
import * as Styles from "../styles/Filters";
import * as Input from "../../../../../../../common-deprecated/styles/v2/toyota/components/Input";

type CheckBoxFilterPropType = {
    filter: FilterType;
    selectedValue: string;
    onSelect: (value: string) => void;
};

const CheckBoxFilter = ({ filter, selectedValue, onSelect }: CheckBoxFilterPropType): JSX.Element => {
    return (
        <Styles.CheckBoxList>
            <Type.H2 headingType="sub-epsilon" mb={3}>
                {filter.label}
            </Type.H2>
            {filter.values.map((value) => (
                <Input.Wrapper variant="radio" key={value.id}>
                    <input
                        id={value.id}
                        onClick={() => onSelect(value.id)}
                        checked={selectedValue === value.id}
                        readOnly
                    />
                    <Input.Radio htmlFor={value.id} checked={selectedValue === value.id}>
                        {value.label}
                    </Input.Radio>
                </Input.Wrapper>
            ))}
        </Styles.CheckBoxList>
    );
};

export default CheckBoxFilter;
